import { createTheme } from '@mui/material/styles';
// import { esES as coreEs, arSD as coreAs } from '@mui/material/locale';
// import { esES as dataGridEs } from '@mui/x-data-grid/locales/esES';
// import { arSD as dataGridAr } from '@mui/x-data-grid/locales/arSD';
// import { esES as datePickerEs } from '@mui/x-date-pickers/locales/esES';
// import datePickerAr from '@mui/x-date-pickers/locales/ar';

// import { Roboto } from 'next/font/google';

// const roboto = Roboto({
//   weight: ['300', '400', '500', '700'],
//   subsets: ['latin'],
//   display: 'swap',
// });

let theme = createTheme(
  {
    typography: {
      fontFamily: '"Roboto", sans-serif',
      body3: {
        fontSize: '0.75rem',
        fontWeight: '500',
        lineHeight: '1.25',
      },
    },
    palette: {
      primary: {
        main: '#9489AB',
      },
      secondary: {
        main: '#4F9FEF',
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: import.meta.env.VITE_STOP_ANIMATIONS === 'true',
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === 'h4' && {
              textTransform: 'uppercase',
            }),
            ...(ownerState.variant === 'h5' && {
              fontWeight: 700,
              fontSize: '1.75rem',
              textTransform: 'uppercase',
            }),
            ...(ownerState.variant === 'caption' && {
              fontWeight: 300,
              fontSize: '12px',
            }),
            ...(ownerState.variant === 'clientTitle' && {
              fontWeight: 500,
              fontSize: 'clamp(1.5rem, 7vw, 3.125rem);',
              color: '#303636',
              textTransform: 'uppercase',
            }),
            ...(ownerState.variant === 'clientSettingsTitle' && {
              color: '#252F40',
              fontSize: '1rem',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: 'normal',
              letterSpacing: '-0.025rem',
              textTransform: 'uppercase',
            }),
          }),
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            borderRadius: '3.75rem',
            padding: '0.625rem 1.625rem',
            ...((ownerState.color === 'winterGreen' ||
              (ownerState.color === 'secondary' &&
                ownerState.variant !== 'outlined')) && {
              color: '#fff',
            }),
            ...(ownerState.variant === 'contained' && {
              padding: '0.375rem 1rem',
            }),
          }),
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            opacity: 0.6,
            textTransform: 'uppercase',
            '&.Mui-disabled': {
              color: '#67748E',
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            textTransform: 'uppercase',
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            border: 0,
          },
        },
      },
      // MuiSvgIcon: {
      //   styleOverrides: {
      //     root: {
      //       fill: 'var(--color-zinc-100)',
      //     },
      //   },
      // },
      MuiInputBase: {
        styleOverrides: {
          root: {
            '&:before': {
              boxShadow: '0px -0.5px 0px 0px rgba(18, 18, 29, 0.10) inset',
              border: '0 !important',
              bottom: '-5px !important',
            },
            '&.Mui-disabled .MuiInputAdornment-root.MuiInputAdornment-filled': {
              display: 'none',
            },
            '&.Mui-disabled .MuiAutocomplete-endAdornment': {
              display: 'none',
            },
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.06) !important',
            },
          },
          input: {
            '&.MuiFilledInput-input.Mui-disabled': {
              color: '#000',
              WebkitTextFillColor: '#000',
            },
          },
        },
      },
      MuiStep: {
        styleOverrides: {
          root: {
            textTransform: 'uppercase',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            textTransform: 'uppercase',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            fontWeight: 500,
            ...(ownerState.color === 'success' &&
              ownerState.variant === 'filled' && {
                color: '#2F9461',
                backgroundColor: '#D9F9E6',
              }),
            ...(ownerState.color === 'warning' &&
              ownerState.variant === 'filled' && {
                color: '#C8811A',
                backgroundColor: '#FBF2CB',
              }),
            ...(ownerState.color === 'error' &&
              ownerState.variant === 'filled' && {
                color: '#CD3636',
                backgroundColor: '#FDE9E9',
              }),
            ...(ownerState.color === 'default' &&
              ownerState.variant === 'filled' && {
                color: '#24292E',
                backgroundColor: '#F6F7F9',
              }),
          }),
        },
      },
    },
  }
  // coreEs,
  // coreAs,
  // datePickerEs,
  // dataGridEs,
  // dataGridAr
);

theme = createTheme(theme, {
  // Custom colors created with augmentColor go here
  palette: {
    salmon: theme.palette.augmentColor({
      color: {
        main: '#D697A4',
      },
      name: 'salmon',
    }),
    winterGreen: theme.palette.augmentColor({
      color: {
        main: '#3FB7AA',
      },
      name: 'winterGreen',
    }),
    black5: theme.palette.augmentColor({
      color: {
        // fill: var(--label-black-5, );
        main: 'rgba(18, 18, 29, 0.05)',
      },
      name: 'black5',
    }),
    grey: theme.palette.augmentColor({
      color: {
        main: '#E5E7EA',
      },
      name: 'grey',
    }),
    warmWater: theme.palette.augmentColor({
      color: {
        main: '#E6F7F7',
      },
      name: 'warmWater',
    }),
    supportText: theme.palette.augmentColor({
      color: {
        main: '#303636',
      },
      name: 'supportText',
    }),
    white: theme.palette.augmentColor({
      color: {
        main: '#fff',
      },
      name: 'white',
    }),
  },
});

export default theme;
